import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./EditEducationModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

function EditEducationModal({ show, handleClose }) {
  const qualificationOptions = [
    { value: "btech", label: "Bachelor Of Technology (B.Tech/B.E)" },
    { value: "be", label: "Bachelor Of Engineering (B.E)" },
    { value: "mtech", label: "Master Of Technology (M.Tech)" },
    { value: "mca", label: "Master Of Computer Applications (MCA)" },
  ];

  const specializationOptions = [
    { value: "cs", label: "Computer Science" },
    { value: "it", label: "Information Technology" },
    { value: "ai", label: "Artificial Intelligence" },
    { value: "ece", label: "Electronics & Communication" },
    { value: "me", label: "Mechanical Engineering" },
  ];

  const collegeOptions = [
    {
      value: "suryodaya",
      label: "Suryodaya College of Engineering & Technology",
    },
    {
      value: "iit",
      label: "Indian Institute of Technology",
    },
    {
      value: "nit",
      label: "National Institute of Technology",
    },
  ];

  const yearOptions = Array.from({ length: 20 }, (_, i) => ({
    value: `${2025 - i}`,
    label: `${2025 - i}`,
  }));

  const [qualification, setQualification] = useState(qualificationOptions[0]);

  const [specialization, setSpecialization] = useState(null);

  const [college, setCollege] = useState(collegeOptions[0]);

  const [passingYear, setPassingYear] = useState(yearOptions[3]);

  const [educationType, setEducationType] = useState("");

  const handleSave = () => {
    console.log({
      qualification,
      specialization,
      college,
      passingYear,
      educationType,
    });

    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal EditEducationModal"
    >
      <Modal.Header className="education-modal__header">
        <Modal.Title>
          {" "}
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>
          Edit education
        </Modal.Title>

        <button className="btn-close" onClick={handleClose}></button>
      </Modal.Header>

      <Modal.Body className="education-modal__body">
        {/* Qualification */}

        <Form.Group className="mb-3">
          <Form.Label className="education-modal__label">
            Qualification <span className="text-danger">*</span>
          </Form.Label>

          <Select
            options={qualificationOptions}
            value={qualification}
            onChange={setQualification}
            classNamePrefix="education-select"
            placeholder="Select Qualification"
          />
        </Form.Group>

        {/* Specialization */}

        <Form.Group className="mb-3">
          <Form.Label className="education-modal__label">
            Specialization/Major <span className="text-danger">*</span>
          </Form.Label>

          <Select
            options={specializationOptions}
            value={specialization}
            onChange={setSpecialization}
            placeholder="Select your specialization"
            classNamePrefix="education-select"
          />

          {!specialization && (
            <div className="education-modal__error">This field is required</div>
          )}
        </Form.Group>

        {/* University */}

        <Form.Group className="mb-3">
          <Form.Label className="education-modal__label">
            University/Institute <span className="text-danger">*</span>
          </Form.Label>

          <Select
            options={collegeOptions}
            value={college}
            onChange={setCollege}
            classNamePrefix="education-select"
            placeholder="Select College"
          />
        </Form.Group>

        {/* Passing Year */}

        <Form.Group className="mb-3">
          <Form.Label className="education-modal__label">
            Passing Year <span className="text-danger">*</span>
          </Form.Label>

          <Select
            options={yearOptions}
            value={passingYear}
            onChange={setPassingYear}
            classNamePrefix="education-select"
          />
        </Form.Group>

        {/* Education Type */}

        <Form.Group>
          <Form.Label className="education-modal__label">
            Education Type <span className="text-danger">*</span>
          </Form.Label>

          <div className="education-modal__chips">
            {["Full time", "Part time", "Correspondence"].map((item) => (
              <button
                key={item}
                type="button"
                className={`education-modal__chip ${
                  educationType === item ? "active" : ""
                }`}
                onClick={() => setEducationType(item)}
              >
                {item}
              </button>
            ))}
          </div>

          {!educationType && (
            <div className="education-modal__error">This field is required</div>
          )}
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="change-phone-footer">
        <Button variant="link" className="education-modal__delete">
          Delete Education
        </Button>
        <Button className="save-btn" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditEducationModal;
